// assets/js/app.js

import {createApp, ref, watch} from "vue";

// import 'vuetify/styles'

import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import GraphAdvancesSearchApp from '../vue/graph_advanced_search.vue'
import GraphFilterApp from '../vue/graph-filter.vue'
import CmAdvancedSearch from '../vue/cm_advanced_search.vue'
import CmFilter from '../vue/cm-filter.vue'
import {searchGraph} from "./api/graphSearch";
import CmEntityAdvancedSearch from '../vue/cm_entity_advanced_search.vue'
import CmERelatedTable from "../vue/cm-e-related-table.vue"
import CmEJournalTable from "../vue/cm-e-journal-table.vue";
import {aliases, fa} from "vuetify/iconsets/fa";
import Mirador from 'mirador'
import Cropper from 'cropperjs';
import flatpickr from "flatpickr";
import {German} from "flatpickr/dist/l10n/de.js";

flatpickr.localize(German); // Flatpickr auf Deutsch stellen

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'fa',
        aliases,
        sets: {fa},
    },
})

window.Cropper = Cropper;

document.addEventListener('DOMContentLoaded', () => {
    initGlobal();
});

function initGlobal() {
    // 1) Klaro Privacy Popup
    const klaroBtn = document.getElementById('klaro-privacy-popup');
    if (klaroBtn && window.klaro && typeof window.klaro.show === 'function') {
        klaroBtn.addEventListener('click', () => window.klaro.show());
    }

    // 2) Search Modal
    const searchModalEl = document.getElementById('searchModal');
    if (searchModalEl) {
        // Bootstrap-Event 'shown.bs.modal' → Input fokussieren (falls vorhanden)
        searchModalEl.addEventListener('shown.bs.modal', () => {
            const input = document.getElementById('inputBox');
            if (input) input.focus();
        });
    }
}

// jQuery normalisieren, aber nur im Browser
//(function () {
//  if (typeof window === 'undefined') return; // verhindert Fehler beim Build
//  var jq = window.jQuery || window.$;
//  if (!jq) return;                            // jQuery noch nicht da
//  if (!window.jQuery) window.jQuery = jq;
//  if (!window.$) window.$ = jq;
//})();

document.addEventListener('DOMContentLoaded', () => {
    initSelect2All();
});

// generische Initialisierung
function initSelect2All() {
    const $ = window.jQuery || window.$;
    if (!($ && $.fn && $.fn.select2)) {
        console.warn('[select2] Plugin nicht geladen – überspringe Init.');
        return;
    }

    // Single-Selects
    $('.js-js-select2-single').each(function () {
        if ($(this).data('select2')) return; // schon initialisiert
        $(this).select2({
            width: '100%',
            theme: 'bootstrap-5',
            allowClear: true,
            placeholder: $(this).data('placeholder') || ''
        });

        // Multi-Selects
        $('.js-select2-multi').each(function () {
            if ($(this).data('select2')) return;
            $(this).select2({
                width: '100%',
                theme: 'bootstrap-5'
            });
        });
    })

    document.addEventListener('DOMContentLoaded', function () {
        document.getElementById('klaro-privacy-popup')
            .addEventListener('click', function () {
                return klaro.show()
            });
    });

    document.addEventListener('DOMContentLoaded', () => {
        let tries = 20;
        const timer = setInterval(() => {
            if (window.jQuery && window.jQuery.fn && window.jQuery.fn.select2) {
                initSelect2All();
                clearInterval(timer);
            } else if (--tries <= 0) {
                clearInterval(timer);
                console.warn('[select2] Plugin nicht verfügbar.');
            }
        }, 100);
    });


    var showingScrollElements = false;
    const TRIGGER_POINT = 100;

    const setScrollVisibility = (value) => {
        if (value === "none") {
            showingScrollElements = false;
        } else if (value === "block") {
            showingScrollElements = true;
        } else {
            throw new Error("Only valid inputs are 'block' and 'none'");
        }

        const elements = document.getElementsByClassName("show-on-scroll");
        Array.from(elements).forEach((element) => {
            element.style.display = value;
        });
    };
}

document.addEventListener('DOMContentLoaded', () => {
    const logoEl = document.getElementById('top-logo');

    if (logoEl) {
        const hasSetScrollVisibility = typeof window.setScrollVisibility === 'function';
        let showingScrollElements = window.showingScrollElements ?? false;

        const onScroll = () => {
            const rect = logoEl.getBoundingClientRect();
            const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
            const triggerPoint = rect.bottom + scrollTop;
            const beyondLogo = scrollTop > triggerPoint;

            if (!hasSetScrollVisibility) return;
            if (showingScrollElements && !beyondLogo) {
                setScrollVisibility('none');
                showingScrollElements = false;
            } else if (!showingScrollElements && beyondLogo) {
                setScrollVisibility('block');
                showingScrollElements = true;
            }
        };

        onScroll();
        document.addEventListener('scroll', onScroll, {passive: true});
        window.addEventListener('resize', onScroll);
    }
});



function searchModalUpdate() {
    document.searchModal.action = document.searchModal.searchTarget.value;
    document.searchModal.lookfor.name = (
        document.searchModal.searchTarget[0].checked ? "lookfor" : "query"
    )

    return true;
}

document.searchModal.addEventListener('submit', function(e) {
    e.preventDefault();

    this.action = this.searchTarget.value;
    this.lookfor.name = (
        this.searchTarget[0].checked ? "lookfor" : "q"
    )

    this.submit();
});

document.getElementById("searchModal").addEventListener(
    "shown.bs.modal",
    function (e) {
        document.getElementById("inputBox").focus();
    }
);

// function scrollTop() {
//   // 500 -> This is the value in px of the distance to be scrolled for the 'scroll-to-top' button to show-up
//   if ($(window).scrollTop() > 500) {
//     $(".backToTopBtn").addClass("active");
//   } else {
//     $(".backToTopBtn").removeClass("active");
//   }
// }
// $(function () {
//   // show and hide btn
//   scrollTop();
//   $(window).on("scroll", scrollTop);

//   // body scroll on btn click
//   $(".backToTopBtn").click(function () {
//     $("html, body").animate({ scrollTop: 0 }, 1);
//     return false;
//   });
// });

if (window.L && L.Icon && L.Icon.Default) {
    L.Icon.Default.mergeOptions({
        iconRetinaUrl: '/static/img/leaflet/marker-icon-2x.png',
        iconUrl: '/static/img/leaflet/marker-icon.png',
        shadowUrl: '/static/img/leaflet/marker-shadow.png',
    });
}

// --- normalize jQuery ---
(function () {
    var jq = window.jQuery || window.$;
    if (!jq) return;
    if (!window.jQuery) window.jQuery = jq;
    if (!window.$) window.$ = jq;
})();

document.addEventListener('DOMContentLoaded', () => {
    const opts = {dateFormat: 'Y-m-d', allowInput: true, altInput: true, altFormat: 'd.m.Y'};
    if (document.querySelector('#id_date_from')) flatpickr('#id_date_from', opts);
    if (document.querySelector('#id_date_to')) flatpickr('#id_date_to', opts);
    document.querySelectorAll('.datepicker').forEach(el => flatpickr(el, opts));
});


window.initMirador = function (elementId, manifestUrl, canvasId) {
    if (!Mirador || typeof Mirador.viewer !== 'function') {
        console.error('Mirador.viewer is not available', Mirador)
        return
    }

    return Mirador.viewer({
        id: elementId,
        windows: [
            {
                manifestId: manifestUrl,
                canvasId: canvasId,
                view: 'single',
            },
        ],

        workspaceControlPanel: {
            enabled: false,
        },

        workspace: {
            showZoomControls: false,
            showWorkspaceControlPanel: false,
        },

        window: {
            allowClose: false,
            allowMaximize: false,
            allowFullscreen: true,
            allowTopMenuButton: false,
            allowWindowSideBar: false,
            hideWindowTitle: true,
        },

        windowViewType: 'single',

        language: 'en',
        availableLanguages: {
            de: 'Deutsch',
            en: 'English',
        },
    });
}

function getBaseParamsFromUrl() {
    const url = new URL(window.location.href);
    const sp = url.searchParams;

    // ✅ diese Parameter wollen wir behalten
    const keep = {};
    for (const k of ["q", "lookfor", "sort", "rows", "page", "q.op"]) {
        const v = sp.get(k);
        if (v != null && v !== "") keep[k] = v;
    }

    if (!keep.q && keep.lookfor) keep.q = keep.lookfor;

    if (!keep.page) keep.page = "1";
    if (!keep.rows) keep.rows = "10";

    const existingFq = sp.getAll("fq");
    return {keep, existingFq};

}

function buildNewUrl({keepParams, fqList}) {
    const url = new URL(window.location.href);
    const sp = url.searchParams;

    // alles löschen und neu setzen (sauber)
    sp.forEach((_, key) => sp.delete(key));

    Object.entries(keepParams).forEach(([k, v]) => sp.set(k, v));
    if (!sp.get("q") && sp.get("lookfor")) sp.set("q", sp.get("lookfor"));

    // ✅ Filter anwenden: fq mehrfach
    (fqList || []).forEach((fq) => sp.append("fq", fq));

    // ✅ Wenn Filter geändert werden, page zurück auf 1
    sp.set("page", "1");

    return url.toString();
}

document.addEventListener("DOMContentLoaded", () => {
    const el = document.querySelector("#graph-filter-app");
    if (!el) return;

    const {keep, existingFq} = getBaseParamsFromUrl();

    const Root = {
        components: {GraphFilterApp},

        setup() {
            const query = ref(keep.q || "*:*");
            const facets = ref({});
            const filters = ref({});
            const loading = ref(false);
            const total = ref(0);

            async function loadFacetsForCurrentQuery() {
                loading.value = true;
                try {
                    const res = await searchGraph({
                        q: query.value,
                        filters: filters.value,
                        extraFq: existingFq,
                        rows: Number(keep.rows || 10),
                        page: Number(keep.page || 1),
                        sort: keep.sort || "",
                    });
                    facets.value = res.facets;
                    total.value = res.total;
                } finally {
                    loading.value = false;
                }
            }

            // ✅ initial laden
            loadFacetsForCurrentQuery();

            // ✅ LIVE Facet Refresh (debounced)
            let debounceTimer = null;
            watch(
                filters,
                () => {
                    clearTimeout(debounceTimer);
                    debounceTimer = setTimeout(() => {
                        loadFacetsForCurrentQuery();
                    }, 300);
                },
                {deep: true}
            );

            function applyFilters({fq}) {
                const newUrl = buildNewUrl({keepParams: keep, fqList: fq});
                window.location.assign(newUrl);
            }

            return {facets, filters, loading, applyFilters, total};
        },


        template: `
          <div>
            <div v-if="loading" class="text-muted mb-2">Loading filters…</div>
            <GraphFilterApp
                :facets="facets"
                v-model="filters"
                @apply="applyFilters"
            />
          </div>
        `,
    };

    const app = createApp(Root);
    app.use(vuetify);
    app.mount("#graph-filter-app");
});


document.addEventListener('DOMContentLoaded', () => {
    //Search-App
    const searchAppEl = document.querySelector('#search-app');
    if (searchAppEl) {
        const app = createApp(GraphAdvancesSearchApp);
        app.use(vuetify);
        app.mount('#search-app');
    }


    // CM Advanced Search
    const CMSearchAppEl = document.querySelector('#cm-search-app')
    if (CMSearchAppEl) {
        const searchUrl = CMSearchAppEl.dataset.searchUrl  // ✅ kommt aus data-search-url
        const app = createApp(CmAdvancedSearch, {searchUrl}) // ✅ Prop reinreichen
        app.use(vuetify)
        app.mount('#cm-search-app')
    }

    // CM Filter (Sidebar)
    const CMFilterEl = document.querySelector('#cm-filter-app')
    if (CMFilterEl) {
        const app = createApp(CmFilter)
        app.use(vuetify)
        app.mount('#cm-filter-app')
    }

    // CM Entity Advanced Search
    const cmESearchEl = document.querySelector('#cm-e-search-app')
    if (cmESearchEl) {
        const searchUrl = cmESearchEl.dataset.searchUrl || window.location.pathname
        const app = createApp(CmEntityAdvancedSearch, {searchUrl})
        app.use(vuetify)
        app.mount('#cm-e-search-app')
    }


    // Read more / Read less
    document.addEventListener('click', (event) => {
        const btn = event.target.closest('.show-hide-btn')
        if (!btn) return
        event.preventDefault()

        const id = btn.dataset.id
        if (!id) return

        const half = document.getElementById(`half-${id}`)
        const full = document.getElementById(`full-${id}`)
        if (!half || !full) return

        const halfVisible = window.getComputedStyle(half).display !== 'none'
        half.style.display = halfVisible ? 'none' : 'block'
        full.style.display = halfVisible ? 'block' : 'none'
    })


    // Automatic opening of accordion in advanced search
    const simpleInput = document.querySelector('form[action*="search"] input[name="q"]')
    if (simpleInput && simpleInput.value) {
        const q = simpleInput.value.trim()

        // Heuristik: Advanced Query, wenn Felder / Operatoren / Klammern etc. vorkommen
        const advancedPattern = /(:|\bAND\b|\bOR\b|\bNOT\b|\(|\)|\*|\[.+ TO .+\])/i

        if (advancedPattern.test(q)) {
            const simpleCollapse = document.getElementById('collapseSimple')
            const advancedCollapse = document.getElementById('collapseAdvanced')
            const simpleBtn = document.querySelector('#headingSimple .accordion-button')
            const advBtn = document.querySelector('#headingAdvanced .accordion-button')

            if (simpleCollapse && advancedCollapse) {
                // Bevorzugt: Bootstrap Collapse API nutzen, falls verfügbar
                if (window.bootstrap && window.bootstrap.Collapse) {
                    const cSimple = new window.bootstrap.Collapse(simpleCollapse, {toggle: false})
                    const cAdvanced = new window.bootstrap.Collapse(advancedCollapse, {toggle: false})

                    cSimple.hide()
                    cAdvanced.show()
                } else {
                    // Fallback: Klassen direkt setzen
                    simpleCollapse.classList.remove('show')
                    advancedCollapse.classList.add('show')
                }
            }

            // Buttons visuell/ARIA korrekt umschalten
            if (simpleBtn && advBtn) {
                simpleBtn.classList.add('collapsed')
                simpleBtn.setAttribute('aria-expanded', 'false')
                advBtn.classList.remove('collapsed')
                advBtn.setAttribute('aria-expanded', 'true')
            }
        }
    }

    // --- Accordion: immer nur den Titel der jeweils *anderen* Suche anzeigen ---
    const collapseSimple = document.getElementById('collapseSimple')
    const collapseAdvanced = document.getElementById('collapseAdvanced')
    const headingSimple = document.getElementById('headingSimple')
    const headingAdvanced = document.getElementById('headingAdvanced')

    function updateSearchHeadings() {
        if (!collapseSimple || !collapseAdvanced || !headingSimple || !headingAdvanced) return

        const simpleOpen = collapseSimple.classList.contains('show')
        const advancedOpen = collapseAdvanced.classList.contains('show')

        // Wenn Simple offen ist → Simple-Heading verstecken, Advanced-Heading zeigen
        headingSimple.style.display = simpleOpen ? 'none' : ''
        headingAdvanced.style.display = advancedOpen ? 'none' : ''
    }

    // Initialer Zustand nach dem Laden
    updateSearchHeadings()

    // Nur wenn Bootstrap JS verfügbar ist, hängen wir Events dran
    if (collapseSimple && collapseAdvanced) {
        // Auf Änderungen der Collapse-States reagieren
        ['shown.bs.collapse', 'hidden.bs.collapse'].forEach((ev) => {
            collapseSimple.addEventListener(ev, updateSearchHeadings)
            collapseAdvanced.addEventListener(ev, updateSearchHeadings)
        })
    }

})

function parseJsonScript(jsonId) {
    if (!jsonId) return [];
    const node = document.getElementById(jsonId);
    if (!node) return [];
    try {
        return JSON.parse(node.textContent || "[]");
    } catch (e) {
        console.error("Invalid JSON in json_script:", jsonId, e);
        return [];
    }
}

// ----

function mountCmERelatedTables() {
    const nodes = document.querySelectorAll(".cm-e-related-table");

    nodes.forEach((el) => {
        const jsonId = el.getAttribute("data-json-id");
        const searchUrl = el.getAttribute("data-search-url") || "/jl/cm-e-search/";
        const items = parseJsonScript(jsonId);

        const app = createApp(CmERelatedTable, {
            items,
            searchUrl,
            itemsPerPage: 10,
        });
        app.use(vuetify);
        app.mount(el);
    });
}

document.addEventListener("DOMContentLoaded", mountCmERelatedTables);


function mountCmEJournalTables() {
    const nodes = document.querySelectorAll(".cm-e-journal-table");

    nodes.forEach((el) => {
        const jsonId = el.getAttribute("data-json-id");
        const items = parseJsonScript(jsonId);

        const mentionsUrl = el.getAttribute("data-mentions-url");
        const cmSearchBase = el.getAttribute("data-cm-search-base");

        const app = createApp(CmEJournalTable, {
            items,
            mentionsUrl,
            cmSearchBase,
            itemsPerPage: 10,
        });

        app.use(vuetify);
        app.mount(el);
    });
}

document.addEventListener("DOMContentLoaded", mountCmEJournalTables);


/*-------------------FAB-------------------------*/
document.addEventListener("DOMContentLoaded", () => {
    const fabBtn = document.getElementById("fab-button");
    const cancelBtn = document.getElementById("fab-cancel");
    const sidebar = document.getElementById("issue-sidebar");
    const launcher = document.getElementById("jl-issue-launcher");

    if (!fabBtn || !sidebar) return;

    const showSidebar = () => sidebar.classList.remove("d-none");
    const hideSidebar = () => sidebar.classList.add("d-none");
    const toggleSidebar = () => sidebar.classList.toggle("d-none");

    fabBtn.addEventListener("click", (e) => {
        e.preventDefault();
        toggleSidebar();
    });

    cancelBtn?.addEventListener("click", (e) => {
        e.preventDefault();
        hideSidebar();
    });

    // --- Wagtail Userbar Overlap Fix ---
    // Wagtail hat eine "user bar" / overlay tools, die häufig rechts unten sitzen.
    // Wenn vorhanden, rücken wir unseren Launcher nach links, damit er nicht überdeckt wird.
    const userbar =
        document.querySelector("#wagtail-userbar") ||
        document.querySelector(".wagtail-userbar") ||
        document.querySelector("[data-wagtail-userbar]");

    const applyUserbarOffset = () => {
        if (!launcher) return;

        let right = 16; // default
        if (userbar) {
            const rect = userbar.getBoundingClientRect();
            const viewportW = window.innerWidth;

            const userbarNearRight = rect.right > viewportW - 10;
            const userbarNearBottom = rect.bottom > window.innerHeight - 10;

            if (userbarNearRight && userbarNearBottom) {
                right = Math.round(rect.width + 16 + 12); // width + gap
            }
        }

        document.documentElement.style.setProperty("--jl-launcher-right", `${right}px`);
    };

    applyUserbarOffset();
    window.addEventListener("resize", applyUserbarOffset);
});

document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("issue-form");
    const feedback = document.getElementById("jl-issue-feedback");
    const sidebar = document.getElementById("issue-sidebar");

    if (!form || !feedback) return;

    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        feedback.className = "alert d-none";
        feedback.innerHTML = "";

        const formData = new FormData(form);

        try {
            const res = await fetch(form.action, {
                method: "POST",
                headers: {
                    "X-Requested-With": "fetch",
                },
                body: formData,
                credentials: "same-origin",
            });

            const data = await res.json();

            if (!data.ok) {
                throw data;
            }

            // ✅ Erfolg
            feedback.className = "alert alert-success";
            feedback.innerHTML = `
        <strong>Issue created successfully.</strong><br>
        ${
                data.github_issue_url
                    ? `<a href="${data.github_issue_url}" target="_blank">View on GitHub</a>`
                    : ""
            }
      `;
            feedback.classList.remove("d-none");

            form.reset();

            // optional: Sidebar schließen
            setTimeout(() => {
                sidebar?.classList.add("d-none");
            }, 2500);

        } catch (err) {
            // ❌ Fehler
            feedback.className = "alert alert-danger";
            feedback.innerHTML =
                err?.errors
                    ? Object.values(err.errors).flat().join("<br>")
                    : "An unexpected error occurred.";
            feedback.classList.remove("d-none");
        }
    });
});
